import {useState, useEffect} from 'react';

import {LocationApplication} from '@application/Site';
import {AccountApplication} from '@application/Account';
import {useOverallInfo} from '@components/_context';

type CalendarDates = {
  minDate?: Date;
  maxDate?: Date;
  unavailableDates: Date[];
};

type UseCalendarDatesReturn = {
  isLoading: boolean;
  payload: CalendarDates | undefined;
};

const parseDate = (date: string | undefined): Date | undefined => {
  return date ? new Date(date) : undefined;
};

export const useCalendarDates = (): UseCalendarDatesReturn => {
  const [isLoading, setIsLoading] = useState(true);
  const [dates, setDates] = useState<CalendarDates>();
  const {id: userId} = useOverallInfo();

  useEffect(() => {
    if (!userId) return;

    (async () => {
      try {
        const {country} = await LocationApplication.getLocale();
        const {minDate, maxDate, unavailableDates = []} = await AccountApplication.getCalendarDates(country, userId);
        setDates({
          minDate: parseDate(minDate),
          maxDate: parseDate(maxDate),
          unavailableDates: unavailableDates.reduce((acc, value) => {
            const date = parseDate(value);
            return date ? [...acc, date] : acc;
          }, [] as Date[]),
        });
      } finally {
        setIsLoading(false);
      }
    })();
  }, [userId]);

  return {isLoading, payload: dates};
};
